import { Button, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CelebBg from "assets/celeb_bg.png";
import Celebration from "assets/celebration.png";
import SuperAdminProfile from "./SuperAdminProfile";
import AdminProfile from "./AdminProfile";
import DistributorProfile from "./DistributorProfile";
import MachineAdminProfile from "./MachineAdminProfile";
import FillingPersonProfile from "./FillingPersonProfile";
import "utils/protos";
import LogoutIcon from '@mui/icons-material/Logout';
import { logoutAction } from "store/reducers/auth";
import { useNavigate } from "react-router-dom";
import LocationAdminProfile from "./LocationAdminProfile";

const NewUserProfile = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const logOut = ()=>{
    dispatch(logoutAction())
    navigate("/login")
  }

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={{
        height: "100vh",
        width: "100vw",
        bgcolor: "primary.lighter",
        backgroundImage: `url(${CelebBg})`,
        backgroundRepeat: "repeat",
        backgroundSize: 280,
      }}
    >
      <Grid item xs={12} md={6} lg={6} xl={4}>
        <Paper sx={{ p: 3, mx: 3, borderRadius: 0 }} elevation={3}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" color="text.secondary">
              Getting started
            </Typography>
            <Button variant="text" startIcon={<LogoutIcon/>} onClick={() => logOut()}>
              Logout
            </Button>
          </Stack>
          <Divider sx={{ mt: 1 }} />
          <Typography variant="h3" color="text.primary" sx={{ my: 1 }}>
            Welcome {auth.user?.user}{" "}
            <img src={Celebration} alt="" style={{ width: 40 }} />
          </Typography>

          <Typography variant="h6" color="text.secondary">
            We're excited to get to know you better, By sharing a few more
            details, we can offer you a more personalized experience
          </Typography>
          <Divider sx={{ mt: 1 }} />
          {auth.user?.roles?.contains("super_admin") && <SuperAdminProfile />}
          {auth.user?.roles?.contains("admin") && <AdminProfile />}
          {auth.user?.roles?.contains("distributor") && <DistributorProfile />}
          {auth.user?.roles?.contains("machine_admin") && (
            <MachineAdminProfile />
          )}
          {auth.user?.roles?.contains("filling_person") && (
            <FillingPersonProfile />
          )}
          {auth.user?.roles?.contains("location_admin") && (
            <LocationAdminProfile />
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default NewUserProfile;
